export default class ToggleAnimations {
    constructor() {
        this.menuVariables = [
            document.querySelectorAll('.jet-mega-menu-toggle'),
            document.getElementsByTagName('body')[0]
        ];
        this.couponVariables = [
            150,
            document.getElementById('apply-coupon-toggler'),
            document.getElementById('apply-coupon-container')
        ];
    }

    init() {
        this.menuToggler(this.menuVariables);
        this.couponToggler(this.couponVariables);
    }

    menuToggler(menuVariables){
        let [toggleMenus,body] = menuVariables;
        toggleMenus.forEach((toggleMenu) => {
            toggleMenu.addEventListener('click', function (e) {
                if (!body.classList.contains('mega-menu-is-open')) {
                    body.classList.add('mega-menu-is-open');
                } else {
                    body.classList.remove('mega-menu-is-open');
                }
            });
        });
    }

    couponToggler(couponVariables){
        let [applyCouponContainerHeight,applyCouponToggler,applyCouponBody] = couponVariables;
        if(applyCouponToggler && applyCouponBody) {
            applyCouponContainerHeight = applyCouponBody.offsetHeight;
            applyCouponToggler.addEventListener('click', (e) => {
                applyCouponToggler.classList.toggle('toggled');
                let isHidden = applyCouponToggler.classList.contains('toggled');
                applyCouponBody.style.visibility = isHidden ? 'hidden' : 'visible';
                applyCouponBody.style.opacity = isHidden ? '0' : '1';
                applyCouponBody.style.height = isHidden ? 0 : `${applyCouponContainerHeight}px`;
            });
        }
    }

}